export default{
    getActiveMiniPlayer(state){
        return state.currentMiniPlayer;
    }
}